module.exports = __webpack_public_path__ + "static/assets/d685575e2b77882df265795f866ebc95.svg";